<script setup>
import { computed } from "vue";

// segments: [{ label, value, color }]
const props = defineProps({
  segments: { type: Array, required: true },
  centerTop: { type: String, default: "" },
  centerSub: { type: String, default: "" },
});

const total = computed(() => props.segments.reduce((a, s) => a + s.value, 0) || 1);

const gradient = computed(() => {
  let acc = 0;
  const stops = props.segments.map((s) => {
    const from = (acc / total.value) * 100;
    acc += s.value;
    const to = (acc / total.value) * 100;
    return `${s.color} ${from.toFixed(2)}% ${to.toFixed(2)}%`;
  });
  return `conic-gradient(${stops.join(", ")})`;
});
</script>

<template>
  <div class="an-donut-wrap">
    <div class="an-donut" :style="{ background: gradient }">
      <div class="an-donut__c"><b>{{ centerTop }}</b><span>{{ centerSub }}</span></div>
    </div>
    <div class="an-keys">
      <div v-for="(s, i) in segments" :key="i">
        <i :style="{ background: s.color }"></i>{{ s.label }} <b>{{ s.value.toLocaleString() }}</b>
      </div>
    </div>
  </div>
</template>
